import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import socialYoutubeImage from './img/Youtube_logo.png';
import socialTwitterImage from './img/Twitter_logo.png';
import socialLinkedinImage from './img/Linkedin_logo.png';

const Social = (props: WithTranslation) => {
    const { t } = props;
    return (
        <div className="social-container">
            <h2 className="header-3 social-title">{t('social_media_title')}</h2>
            <div className="social-icon-container ">
                <a href={t('social_media_linkedin_url')} rel="noreferrer" target="_blank">
                    <img
                        className="social-icon"
                        src={socialLinkedinImage}
                        alt={t('social_media_linkedin_aria_label', { ns: 'accessibility' })}
                    />
                </a>
                <a href={t('social_media_twitter_url')} rel="noreferrer" target="_blank">
                    <img
                        className="social-icon"
                        src={socialTwitterImage}
                        alt={t('social_media_twitter_aria_label', { ns: 'accessibility' })}
                    />
                </a>
                <a href={t('social_media_youtube_url')} rel="noreferrer" target="_blank">
                    <img
                        className="social-icon"
                        src={socialYoutubeImage}
                        alt={t('social_media_youtube_aria_label', { ns: 'accessibility' })}
                    />
                </a>
            </div>
        </div>
    );
};

export default withTranslation()(Social);
